import { useContext, useRef, useState } from 'react';
import { json, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';

import Edit2Icon from '@svgs/Edit2.svg?react';
import ExternalLinkIcon from '@svgs/ExternalLink.svg?react';
import MonitorIcon from '@svgs/Monitor.svg?react';
import MoreHorizontalIcon from '@svgs/MoreHorizontal.svg?react';

import { GlobalContext } from '@contexts';
import { locationsQuery } from '@queries';

import './ProjectCard.scss';

export const ProjectCard = ({ business, siteThumbnail }) => {
  const { t, i18n } = useTranslation();
  const globals = useContext(GlobalContext);

  // Fetch project locations
  const { data: locationsData, isPending: locationsIsPending } = useQuery(
    locationsQuery({
      business_id: business.id,
      published: 1,
      limit: 1,
      _fields: 'id'
    }),
  );

  // menu activation
  const dropdownMenu = useRef(null);
  const [showDropdownMenu, setShowDropdownMenu] = useState(false);
  const closeOpenMenus = (e) => {
    if (showDropdownMenu && !dropdownMenu.current?.contains(e.target)) {
      setShowDropdownMenu(false);
    }
  };
  document.addEventListener('mousedown', closeOpenMenus);

  return (
    <div className="sb-project-item">
      <div>
        <Link to={`/dashboard/projects/${business.id}/sites`}>
          <span className="img-contain">
            <img
              src={
                siteThumbnail ||
                '/assets/ScreenshotPlaceholder.svg'
              }
              alt={business.business_name}
              width="640"
              height="400"
            />
          </span>
        </Link>
      </div>
      <div className="sb-project-info sb-flex">
        <div>
          <p>
            <Link to={`/dashboard/projects/${business.id}/sites`}>
              {business.business_name}
            </Link>
          </p>
          {business.primary_domain && (
            <p className="sb-project-card--primary-domain">
              {business.primary_domain}
            </p>
          )}
          {locationsIsPending && (
            <p className="sb-project-card--locations">...</p>
          )}
          {!locationsIsPending && (
            <p className="sb-project-card--locations">
              {locationsData.meta.total_count} location
              {locationsData.meta.total_count != 1 ? 's' : ''}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
